import { initialState } from '../reducers/historyReducer';
import { peek, selector } from '../selectorHelpers';

export const historySelect = (state) => state.get('history', initialState);

// Manifest list grouped by week: Map { "YYYY-WW": List([manifest, ...]) }
export const historySelectItems = selector(historySelect, peek('items'));

// Week range labels: Map { "YYYY-WW": "Nov 25 – Dec 1" }
export const historySelectWeekRanges = selector(
  historySelect,
  peek('weekRanges'),
);

// Manifest detail cache: Map { manifestId: ManifestDetail }
export const historySelectManifestDetail = selector(
  historySelect,
  peek('manifestDetail'),
);

export const historySelectTotalPages = selector(
  historySelect,
  peek('totalPages'),
);

export const historySelectLoading = selector(historySelect, peek('isLoading'));

export const historySelectDetailedLoading = selector(
  historySelect,
  peek('isDetailedLoading'),
);

export const historySelectDetailedShipment = selector(
  historySelect,
  peek('detailedShipment'),
);

export const historySelectDetailedShipmentLoading = selector(
  historySelect,
  peek('isLoadingDetailedShipment'),
);

export const historySelectFullDetailedConsolidation = selector(
  historySelect,
  peek('fullDetailedConsolidation'),
);

// Year selector + infinite scroll selectors
export const historySelectAvailableYears = selector(
  historySelect,
  peek('availableYears'),
);

export const historySelectIsLoadingMore = selector(
  historySelect,
  peek('isLoadingMore'),
);

export const historySelectHasMorePages = selector(
  historySelect,
  peek('hasMorePages'),
);

export const historySelectCurrentPage = selector(
  historySelect,
  peek('currentPage'),
);
